// frontend/src/components/ResendStatus.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ResendStatus = () => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const checkStatus = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/admin/email/resend-status');
      setStatus(response.data);
      setError(null);
    } catch (err) {
      setError(err.response?.data || { message: 'Failed to check Resend status' });
      setStatus(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkStatus();
  }, []);

  const getStatusColor = () => {
    if (!status) return 'bg-gray-100';
    if (status.success) return 'bg-green-100';
    if (status.status === 'rate_limited') return 'bg-yellow-100';
    if (status.status === 'quota_exceeded') return 'bg-red-100';
    return 'bg-gray-100';
  };

  const getStatusText = () => {
    if (!status) return 'Unknown';
    if (status.success) return 'Active';
    if (status.status === 'rate_limited') return 'Rate Limited';
    if (status.status === 'quota_exceeded') return 'Quota Exceeded';
    return 'Unknown';
  };

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <h2 className="text-lg font-semibold mb-4">Resend API Status</h2>
      
      {loading ? (
        <div className="flex items-center space-x-2">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-900"></div>
          <span>Checking status...</span>
        </div>
      ) : error ? (
        <div className="text-red-600">
          Error: {error.message}
        </div>
      ) : (
        <div className="space-y-4">
          <div className="flex items-center space-x-2">
            <div className={`w-3 h-3 rounded-full ${getStatusColor()}`}></div>
            <span className="font-medium">{getStatusText()}</span>
          </div>
          
          {status?.data && (
            <div className="text-sm text-gray-600 space-y-1">
              <p>Rate Limit: {status.data.rateLimit}</p>
              <p>Daily Quota: {status.data.dailyQuota}</p>
            </div>
          )}
          
          {status?.status === 'rate_limited' && (
            <div className="text-sm text-yellow-600">
              Rate limit exceeded. Please wait before sending more emails.
            </div>
          )}
          
          {status?.status === 'quota_exceeded' && (
            <div className="text-sm text-red-600">
              Daily quota exceeded. Please try again tomorrow.
            </div>
          )}
          
          <button
            onClick={checkStatus}
            className="text-sm text-blue-600 hover:text-blue-800"
          >
            Refresh Status
          </button>
        </div>
      )}
    </div>
  );
};

export default ResendStatus; 